<template>
  <select v-model="selectedVisibility"
          class="custom-select form-text-dark"
          @change="$emit('update', selectedVisibility)">
    <option v-if="allowNullValue" :value="null">{{ $t('filter.all') }}</option>
    <option :value="TeamVisibility.PRIVATE">{{ $t('filter.private') }}</option>
    <option :value="TeamVisibility.PUBLIC">{{ $t('filter.public') }}</option>
    <option :value="TeamVisibility.GLOBAL">{{ $t('filter.global') }}</option>
  </select>
</template>

<script>
import {TeamVisibility} from "@/enum";

export default {
  name: "TeamVisibilityDropdown",
  props: {
    initialValue: {type: Number, default: null},
    allowNullValue: {type: Boolean, default: true},
  },
  data() {
    return {
      selectedVisibility: null,
      TeamVisibility,
    };
  },
  watch: {
    initialValue() {
      this.selectedVisibility = this.initialValue;
    }
  },
  beforeMount() {
    this.selectedVisibility = this.initialValue;
  },
}
</script>

<style lang="scss" scoped>

</style>